/* ========================================================================
   Healthier Options — hero headline word reveal
   Splits each [data-ho-hero-reveal] heading into <span class="ho-word">
   children and sets --word-index for the CSS cascade in ho-animations.css.
   One-time play on DOMContentLoaded. Skipped under prefers-reduced-motion.
   ======================================================================== */
(function () {
  function splitIntoWords(rootEl) {
    if (rootEl.dataset.hoRevealDone === '1') return;
    var walker = document.createTreeWalker(rootEl, NodeFilter.SHOW_TEXT, null);
    var textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    var wordIndex = 0;
    textNodes.forEach(function (node) {
      var text = node.nodeValue;
      if (!text || !text.trim()) return;
      var frag = document.createDocumentFragment();
      var tokens = text.split(/(\s+)/);
      tokens.forEach(function (tok) {
        if (!tok) return;
        if (/^\s+$/.test(tok)) {
          frag.appendChild(document.createTextNode(' '));
          return;
        }
        var span = document.createElement('span');
        span.className = 'ho-word';
        span.style.setProperty('--word-index', wordIndex++);
        span.textContent = tok;
        frag.appendChild(span);
      });
      node.parentNode.replaceChild(frag, node);
    });
    rootEl.dataset.hoRevealDone = '1';
  }

  function run() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var targets = document.querySelectorAll('[data-ho-hero-reveal]');
    targets.forEach(splitIntoWords);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-run after Shopify section reloads in theme editor.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', run);
  }
})();
